import { useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
export function useDrag(addFiles) {
  var instance = useInstance();
  var dragOver = useState(false);
  var counter = 0;
  function onDragEnter(e) {
    e.preventDefault();
    counter++;
    if (dragOver.value || instance.get('disabled')) return;
    dragOver.set(true);
  }
  function onDragLeave(e) {
    counter--;
    if (!counter) {
      dragOver.set(false);
    }
  }
  function onDrop(e) {
    stopEvent(e);
    counter = 0;
    if (!instance.get('disabled')) {
      dragOver.set(false);
      addFiles(e.dataTransfer.files);
    }
  }
  function stopEvent(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  return {
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave,
    onDrop: onDrop,
    stopEvent: stopEvent,
    dragOver: dragOver
  };
}